import {
  RESET_SYSTEM_USERS,
  RESET_SYSTEM_USER,
  RESET_ERROR,
  GET_SYSTEM_USERS,
  SET_SYSTEM_USERS,
  API_ERROR,
  CREATE_SYSTEM_USER,
  CREATE_SYSTEM_USER_SUCCESS,
  GET_SYSTEM_USER,
  SET_SYSTEM_USER,
  EDIT_SYSTEM_USER,
  EDIT_SYSTEM_USER_SUCCESS,
  ACTIVATE_SYSTEM_USER,
  ACTIVATE_SYSTEM_USER_SUCCESS,
} from "./actionTypes";

const initialState = {
  errorSystemUser: false,
  loadingSystemUser: false,
  dataSystemUser: null,
  successSystemUser: false,
};

const SystemUser = (state = initialState, action) => {
  switch (action.type) {
    case RESET_SYSTEM_USERS:
      state = {
        ...state,
        errorSystemUser: false,
        loadingSystemUser: false,
        loadingSystemUserActivate: false,
        successSystemUser: false,
        dataSystemUser: null,
        dataSystemUserActivate: null,
      };
      break;
    case RESET_SYSTEM_USER:
      state = {
        ...state,
        errorSystemUser: false,
        loadingSystemUser: false,
        successSystemUser: false,
        dataSystemUserGetSet: null,
        dataSystemUserEditCreate: null,
      };
      break;
    case RESET_ERROR:
      state = {
        ...state,
        errorSystemUser: false,
        loadingSystemUser: false,
        loadingSystemUserEditCreate: false,
        loadingSystemUserActivate: false,
        successSystemUser: false,
      };
      break;
    case GET_SYSTEM_USERS:
      state = {
        ...state,
        errorSystemUser: false,
        loadingSystemUser: true,
        dataSystemUser: null,
      };
      break;
    case SET_SYSTEM_USERS:
      state = {
        ...state,
        errorSystemUser: false,
        loadingSystemUser: false,
        dataSystemUser: action.payload,
      };
      break;
    case CREATE_SYSTEM_USER:
      state = {
        ...state,
        errorSystemUser: false,
        loadingSystemUserEditCreate: true,
        dataSystemUserEditCreate: action.payload,
        successSystemUser: false,
      };
      break;
    case CREATE_SYSTEM_USER_SUCCESS:
      state = {
        ...state,
        errorSystemUser: false,
        loadingSystemUserEditCreate: false,
        dataSystemUserEditCreate: action.payload,
        successSystemUser: true,
      };
      break;
    case GET_SYSTEM_USER:
      state = {
        ...state,
        errorSystemUser: false,
        loadingSystemUser: true,
        dataSystemUserGetSet: null,
      };
      break;
    case SET_SYSTEM_USER:
      state = {
        ...state,
        errorSystemUser: false,
        loadingSystemUser: false,
        dataSystemUserGetSet: action.payload,
      };
      break;
    case EDIT_SYSTEM_USER:
      state = {
        ...state,
        errorSystemUser: false,
        loadingSystemUserEditCreate: true,
        dataSystemUserEditCreate: action.payload,
        successSystemUser: false,
      };
      break;
    case EDIT_SYSTEM_USER_SUCCESS:
      state = {
        ...state,
        errorSystemUser: false,
        loadingSystemUserEditCreate: false,
        dataSystemUserEditCreate: action.payload,
        successSystemUser: true,
      };
      break;
    case API_ERROR:
      state = {
        ...state,
        errorSystemUser: action.payload,
        loadingSystemUser: false,
        loadingSystemUserActivate: false,
        successSystemUser: false,
      };
      break;
    case ACTIVATE_SYSTEM_USER:
      state = {
        ...state,
        errorSystemUser: false,
        loadingSystemUserActivate: true,
        dataSystemUserActivate: null,
        successSystemUser: false,
      };
      break;
    case ACTIVATE_SYSTEM_USER_SUCCESS:
      state = {
        ...state,
        errorSystemUser: false,
        loadingSystemUserActivate: false,
        dataSystemUserActivate: action.payload,
        successSystemUser: true,
      };
      break;
    default:
      // state = { ...state, error: false, loading: false };
      break;
  }
  return state;
};

export default SystemUser;
